import { LabeledDatePipe } from './labeled-date.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeHtmlPipe } from './safe-html.pipe';
import { FormatPhone } from './format-phone.pipe';



@NgModule({
  declarations: [
    LabeledDatePipe,
    SafeHtmlPipe,
    FormatPhone
  ],
  imports: [
    CommonModule
  ],
  exports: [
    LabeledDatePipe,
    SafeHtmlPipe,
    FormatPhone
  ]
})
export class PipesModule { }
